import { render, staticRenderFns } from "./PlayerEmbed.vue?vue&type=template&id=0794ef87&scoped=true&"
import script from "./PlayerEmbed.vue?vue&type=script&lang=js&"
export * from "./PlayerEmbed.vue?vue&type=script&lang=js&"
import style0 from "./PlayerEmbed.vue?vue&type=style&index=0&id=0794ef87&scoped=true&lang=css&"
import style1 from "./PlayerEmbed.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794ef87",
  null
  
)

export default component.exports